export default "__VITE_ASSET__In2HwAMX__"